import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "bootstrap-icons/font/bootstrap-icons.css";

import testimonial1 from '../assets/img/ceo img.png';
import testimonial2 from '../assets/img/ceo img 2.png';
import testimonial3 from '../assets/img/ceo img 1.avif';
import testimonial4 from '../assets/img/ceo img 3.jpg';
import testimonial5 from '../assets/img/ceo img 4.jpg';



// Sample Testimonials Data
const testimonials = [
  {
    image: testimonial1,
    name: "Aarav Patel",
    role: "Software Engineer",
    quote:
      "The career guidance sessions provided invaluable insights that helped me transition smoothly from college to a full-time job. The mentors are incredibly knowledgeable and supportive!",
    stars: 5,
  },
  {
    image: testimonial2,
    name: "Meera Sharma",
    role: "UX Designer",
    quote:
      "I was struggling to decide on a career path, but the personalized advice I received here changed everything. Their resume and portfolio tips landed me my dream job!",
    stars: 5,
  },
  {
    image: testimonial3,
    name: "Karthik Rajan",
    role: "Entrepreneur",
    quote:
      "The entrepreneurial guidance I received was top-notch. From crafting a business plan to networking effectively, this platform has been a game-changer for my startup journey.",
    stars: 5,
  },
  {
    image: testimonial4,
    name: "Neha Gupta",
    role: "Data Analyst",
    quote:
      "The mock interview sessions were a lifesaver! They prepared me for real-world interviews, and now I’m working at one of the top companies in my field. Highly recommend their services.",
    stars: 5,
  },
  {
    image: testimonial5,
    name: "Rohan Verma",
    role: "Digital Marketing Specialist",
    quote:
      "The team provided me with incredible insights on certifications and skill-building for digital marketing. Their career roadmap made my path crystal clear. Thank you for the guidance!",
    stars: 5,
  },
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="testimonials section">
      <div className="container section-title" data-aos="fade-up">
        <h2>Testimonials</h2>
        <p>What they are saying about us</p>
      </div>
      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <Swiper
          modules={[Autoplay, Pagination]}
          loop={true}
          speed={600}
          autoplay={{ delay: 5000 }}
          slidesPerView="auto"
          pagination={{ clickable: true }}
          breakpoints={{
            320: { slidesPerView: 1, spaceBetween: 40 },
            1200: { slidesPerView: 3, spaceBetween: 1 },
          }}
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index}>
              <div className="testimonial-item">
                <div className="stars">
                  {[...Array(testimonial.stars)].map((_, i) => (
                    <i key={i} className="bi bi-star-fill"></i>
                  ))}
                </div>
                <p>{testimonial.quote}</p>
                <div className="profile mt-auto">
                  <img
                    src={testimonial.image}
                    className="testimonial-img"
                    alt={testimonial.name}
                  />
                  <h3>{testimonial.name}</h3>
                  <h4>{testimonial.role}</h4>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonials;
